import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
    Alert,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Typography,
} from "@mui/material";

export default function ModalRechazarProveedor({
    open,
    onClose,
    onConfirm,
    email,
    razonSocial,
    nroCuit,
    loading = false,
}) {
    const [motivo, setMotivo] = useState("");

    useEffect(() => {
        if (!open) {
            setMotivo("");
        }
    }, [open]);

    const emailTrim = String(email ?? "").trim();
    const tieneCorreo = emailTrim.length > 0;
    const nombreProveedor = String(razonSocial ?? "").trim();
    const cuitProveedor = String(nroCuit ?? "").trim();

    const handleConfirm = () => {
        const motivoTrim = motivo.trim();
        if (!motivoTrim) return;
        onConfirm(motivoTrim);
    };

    return (
        <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="sm" fullWidth>
            <DialogTitle
                sx={{
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    pr: 1,
                }}
            >
                Rechazar proveedor
                <IconButton
                    aria-label="cerrar"
                    onClick={onClose}
                    disabled={loading}
                    edge="end"
                    size="small"
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body1" color="text.secondary">
                    Está por rechazar al proveedor
                    {nombreProveedor ? (
                        <>
                            {" "}
                            <Box component="span" sx={{ fontWeight: 600, color: "text.primary" }}>
                                {nombreProveedor}
                            </Box>
                        </>
                    ) : null}
                    {cuitProveedor ? (
                        <>
                            {" "}
                            <Box component="span" sx={{ fontWeight: 600, color: "text.primary" }}>
                                (CUIT {cuitProveedor})
                            </Box>
                        </>
                    ) : null}
                    .
                </Typography>

                {tieneCorreo ? (
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                            Se le informará al mismo al correo general que registró previamente:
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{ mt: 1, fontWeight: 600, wordBreak: "break-word" }}
                        >
                            {emailTrim}
                        </Typography>
                    </Box>
                ) : (
                    <Alert severity="warning" sx={{ mt: 2 }}>
                        El proveedor no registró un correo electrónico general. Deberá comunicarle
                        de manera externa el rechazo y el motivo que indique a continuación.
                    </Alert>
                )}

                <TextField
                    autoFocus
                    required
                    multiline
                    minRows={3}
                    fullWidth
                    label="Motivo del rechazo"
                    placeholder="Indique el motivo del rechazo"
                    value={motivo}
                    onChange={(e) => setMotivo(e.target.value)}
                    disabled={loading}
                    sx={{ mt: 3 }}
                    helperText="Campo obligatorio"
                    inputProps={{ maxLength: 500 }}
                />
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onClose} color="inherit" disabled={loading}>
                    Cancelar
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    onClick={handleConfirm}
                    disabled={loading || !motivo.trim()}
                >
                    {loading ? "Rechazando..." : "Confirmar rechazo"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
